<script>
export default [
    {
        type: 'columns',
        description: 'Колонки',
        representation: `<span class="fa fa-table"></span>`,
        registered: true, 
        styles: [
            'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight',
            'marginTop', 'marginBottom', 'marginLeft', 'marginRight',
            'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 
            'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'verticalAlign', 'align', 'height', 'borderColor',
            'backgroundImage', 'backgroundSize', 'backgroundRepeat',
        ]
    },
    {
        type: 'editable',
        description: 'Текст',
        representation: `<span class="fa fa-align-justify"></span>`,
        registered: true,
        styles: []
    },
    {
        type: 'btn',
        description: 'Кнопка',
        representation: `<span class="fa fa-hand-pointer-o"></span>`,
        registered: true,
        styles: [
            'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth',
            'borderLeftWidth', 'borderRightWidth', 'borderColor',
            'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight',
            'marginTop', 'marginBottom', 'marginLeft', 'marginRight',
            'backgroundImage', 'backgroundSize', 'backgroundRepeat'
        ],
        style: {
            color: '#ffffff',
            backgroundColor: '#000000',
            borderRadius: '5px',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
        }
    },
    {
        type: 'pic',
        description: 'Изображение',
        representation: `<span class="fa fa-image"></span>`,
        registered: true,
        styles: [
            'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth',
            'borderLeftWidth', 'borderRightWidth', 'borderColor', 'paddingTop', 'paddingBottom',
            'paddingLeft', 'paddingRight', 
        ]
    },
    {
        type: 'spacer',
        description: 'Разделитель',
        representation: `<span class="fa fa-arrows-v"></span>`,
        registered: true,
        styles: [
            'width', 'height', 'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth',
            'borderLeftWidth', 'borderRightWidth', 'borderColor',
            'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 
            'marginTop', 'marginBottom', 'marginLeft', 'marginRight',
        ],
        style: { 
            height: '10px'
        }
    },
    {
        type: 'share',
        description: 'Поделиться',
        representation: `<span class="fa fa-share"></span>`,
        registered: true,
        styles: [
            'width', 'height', 'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth',
            'borderLeftWidth', 'borderRightWidth', 'borderColor', 'paddingTop', 'paddingBottom',
            'paddingLeft', 'paddingRight', 
        ]
    },
    {
        type: 'sociallinks',
        description: 'Соц. сети',
        representation: `<span class="fa fa-facebook"></span>`,
        registered: true,
        styles: [
            'width', 'height', 'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth',
            'borderLeftWidth', 'borderRightWidth', 'borderColor', 'paddingTop', 'paddingBottom',
            'paddingLeft', 'paddingRight', 
        ]
    },
]
</script>
